import type { TranslationMessages } from '../types';

export const orders: TranslationMessages = {
  name: 'Đơn hàng |||| Đơn hàng',
  modern: {
    version: 'Phiên bản',
    title: 'Đơn hàng',
    subtitle: 'Quản lý và theo dõi tất cả đơn hàng',
    search: 'Tìm kiếm số đơn hàng, khách hàng, ghi chú, bàn...',
    filters: 'Bộ lọc',
    export: 'Xuất',
    loading: 'Đang tải đơn hàng...',
    noOrders: 'Không tìm thấy đơn hàng',
    tryFilters: 'Thử điều chỉnh bộ lọc của bạn',
    walkInCustomer: 'Khách vãng lai',
    dineIn: 'Dùng tại chỗ',
    dineInTable: 'Dùng tại chỗ (Bàn %{tableNumber})',
    noAddressOnFile: 'Không có địa chỉ trong hồ sơ',
    addressNotAvailable: 'Địa chỉ không khả dụng',
    items: 'mục',
    noNotes: 'Không có ghi chú',
    returned: 'Đã trả lại',
    columns: 'Cột',
    showColumns: 'Hiển thị cột',
    resetColumns: 'Đặt lại mặc định',
    pagination: {
      showing: 'Hiển thị %{start} đến %{end} trong tổng số %{total} kết quả',
      previous: 'Trước',
      next: 'Tiếp',
    },
    actions: {
      updateStatus: 'Cập nhật trạng thái đơn hàng',
    },
    activeFilters: 'Bộ lọc đang hoạt động',
    productSummary: 'Tóm tắt sản phẩm',
    item: 'Mục',
    productId: 'ID Sản phẩm',
    note: 'Ghi chú',
    noItems: 'Không tìm thấy mục nào',
  },
  amount: '1 đơn hàng |||| %{smart_count} đơn hàng',
  title: 'Đơn hàng %{reference}',
  create: 'Tạo đơn hàng',
  edit: 'Chỉnh sửa đơn hàng',
  editSuborder: 'Chỉnh sửa đơn phụ',
  actions: {
    printBill: 'In hóa đơn',
    cancel: 'Hủy',
    tagCustomer: 'Gắn khách hàng',
    clearCustomer: 'Xóa lựa chọn khách hàng',
    createCustomer: 'Tạo khách hàng mới',
    createSuborder: 'Tạo đơn phụ',
    viewParentOrder: 'Xem đơn hàng cha',
    ready: 'Sẵn sàng',
    cancel_confirm_title: 'Hủy đơn hàng',
    cancel_confirm_message: 'Bạn có chắc chắn muốn hủy đơn hàng này không?',
    force_release: 'Giải phóng bàn cưỡng bức',
    checkInForBenefits: 'Điểm danh để nhận lợi ích',
    force_release_confirm:
      'Bạn có chắc chắn muốn giải phóng bàn này cưỡng bức? Điều này sẽ làm cho bàn có sẵn bất kể các đơn hàng khác.',
    release_all_tables: 'Giải phóng tất cả bàn',
    release_all_tables_title: 'Giải phóng tất cả bàn',
    release_all_tables_message:
      'Điều này sẽ giải phóng tất cả các bàn đang sử dụng và làm cho chúng có sẵn cho các đơn hàng mới. Hành động này không thể hoàn tác.',
    confirm_release_all: 'Giải phóng tất cả bàn',
    occupied_tables_count: 'Bàn đang sử dụng (%{count})',
    no_occupied_tables: 'Không tìm thấy bàn đang sử dụng.',
    releasing: 'Đang giải phóng...',
    print_bill: 'In hóa đơn',
    deliver: 'Giao hàng',
    addProduct: 'Thêm sản phẩm',
    updateProfile: 'Cập nhật hồ sơ',
    useMaxPoints: 'Sử dụng điểm tối đa',
    resetPoints: 'Đặt lại điểm',
    verifyOtp: 'Xác thực OTP',
    verify: 'Xác thực',
    selectTable: 'Chọn bàn',
    changeTable: 'Đổi bàn',
    fixedTables: 'Bàn cố định (1-16)',
    make_payment: 'Thanh toán',
    item_status: 'Trạng thái mục',
  },
  messages: {
    loading: 'Đang tải',
    unknownCustomer: 'Khách vãng lai',
    noProductsFound: 'Không tìm thấy sản phẩm',
    total: 'Tổng cộng',
    totalBeforeDiscount: 'Tổng trước giảm giá',
    selectTableFirst: 'Vui lòng chọn bàn trước',
    verifyCustomerFirst: 'Vui lòng xác thực khách hàng đã chọn',
    customerTaggedForMetrics:
      'Khách hàng đã được gắn để theo dõi số liệu. Điểm danh để sử dụng lợi ích thành viên.',
    customerLocked:
      'Đơn hàng này đã có khách hàng và không thể thay đổi.',
    tagCustomerForMetrics:
      'Gắn khách hàng để bật theo dõi số liệu khách hàng cho đơn hàng này.',
    customerTagged: 'Gắn khách hàng thành công',
    selectTableAndCustomer: 'Vui lòng chọn cả bàn và khách hàng',
    selectProducts: 'Vui lòng chọn ít nhất một sản phẩm',
    enterOtp: 'Vui lòng nhập mã OTP để xác thực',
    completeProfile: 'Vui lòng hoàn thành hồ sơ của bạn',
    qrScanFailed: 'Quét QR thất bại',
    profileUpdateSuccess: 'Cập nhật hồ sơ thành công',
    profileUpdateFailed: 'Cập nhật hồ sơ thất bại',
    checkinSuccess: 'Điểm danh thành công',
    checkinFailed: 'Điểm danh thất bại',
    invalidOtp: 'OTP không hợp lệ',
    otpExpired: 'OTP đã hết hạn',
    otpUsed: 'OTP đã được sử dụng',
    otpNotFound: 'Không tìm thấy OTP',
    checkinCooldown:
      'Vui lòng đợi %{minutes} phút trước khi điểm danh lại',
    customerNotFound: 'Không tìm thấy khách hàng',
    availablePoints: 'Điểm khả dụng: %{points}',
    pointsValue: 'Giá trị điểm: %{value} VND',
    pointsDiscount: 'Sử dụng %{points} điểm (-%{value} VND)',
    remainingPoints: 'Điểm còn lại: %{points}',
    minPointsRedemption: 'Giá trị điểm tối thiểu phải là 5,000 VND',
    exceedAvailablePoints: 'Giá trị điểm không thể vượt quá điểm khả dụng',
    pointsMultipleOf1000: 'Giá trị điểm phải là bội số của 1,000 VND',
    pointsRedemptionHelp:
      'Nhập điểm để đổi (1 điểm = 100 VND, tối thiểu 50 điểm)',
    insufficientOrderAmount:
      'Số tiền đơn hàng phải ít nhất 5,000 VND nhiều hơn giá trị điểm',
    registerForMembership: 'Đăng ký thành viên để tích điểm',
    verifyOtp: 'Xác thực OTP',
    percentageExceeded: 'Phần trăm không thể vượt quá 100%',
    fixedAmountExceeded: 'Số tiền cố định không thể vượt quá tổng số tiền',
    customTableNumber: 'Số bàn tùy chỉnh',
    enterTableNumber: 'Nhập số bàn (>16)',
    tableRequired: 'Số bàn là bắt buộc cho đơn hàng dùng tại chỗ',
    noTableSelected: 'Chưa chọn bàn',
    tableOccupied: 'Bàn đang được sử dụng',
    noCustomer: 'Chưa chọn khách hàng',
    orderCannotBeModified: 'Đơn hàng này không thể chỉnh sửa',
    orderDeliveredCannotBeModified:
      'Đơn hàng này đã được giao và không thể chỉnh sửa.',
    orderCancelledCannotBeModified:
      'Đơn hàng này đã bị hủy và không thể chỉnh sửa.',
    orderReadyCannotBeModified:
      'Đơn hàng ở trạng thái "sẵn sàng" không thể chỉnh sửa. Tạo đơn phụ để thêm mục.',
    suborderCreated: 'Tạo đơn phụ thành công',
    suborderCreateFailed: 'Tạo đơn phụ thất bại',
    noSuborders: 'Chưa có đơn phụ',
    suborderEditRestriction:
      'Đây là đơn phụ. Bạn có thể chỉnh sửa mục, nhưng các trường khác (khách hàng, bàn, khuyến mãi, ngày) không thể thay đổi.',
    originalItem: 'Gốc',
    selectCustomer: 'Chọn khách hàng',
    searchCustomer: 'Tìm kiếm khách hàng...',
    noCustomersFound: 'Không tìm thấy khách hàng.',
    createCustomerDescription:
      'Nhập tên khách hàng để tạo hồ sơ khách hàng mới.',
    enterCustomerName: 'Nhập tên khách hàng',
    createCustomerError: 'Tạo khách hàng thất bại',
    creatingCustomer: 'Đang tạo...',
    qrScannerPlaceholder: 'Máy quét QR sẽ được triển khai ở đây',
    scannerReady: 'Máy quét sẵn sàng',
    scanning: 'Đang quét...',
    processing: 'Đang xử lý...',
    scannerInstructions: 'Hướng dẫn máy quét',
    pointCamera: 'Hướng camera vào mã QR',
    ensureGoodLighting: 'Đảm bảo ánh sáng tốt',
    holdSteady: 'Giữ camera ổn định',
  },
  show: {
    title: 'Đơn hàng',
  },
  fields: {
    orderInformation: 'Thông tin đơn hàng',
    subtotal: 'Tổng phụ',
    date: 'Ngày',
    reference: 'Tham chiếu',
    items: 'Mục',
    totalExTaxes: 'Tổng (chưa thuế)',
    deliveryFees: 'Phí giao hàng',
    basket: {
      delivery: 'Giao hàng',
      reference: 'Tham chiếu',
      quantity: 'Số lượng',
      sum: 'Tổng',
      tax_rate: 'Thuế suất',
      taxes: 'Thuế',
      total: 'Tổng cộng',
      unit_price: 'Đơn giá',
    },
    address: 'Địa chỉ',
    customer: 'Khách hàng',
    firstName: 'Tên',
    lastName: 'Họ',
    customer_id: 'Khách hàng',
    customerPoints: 'Điểm: %{points}',
    date_gte: 'Từ ngày',
    date_lte: 'Đến ngày',
    nb_items: 'Số mục',
    total_gte: 'Số tiền tối thiểu',
    status: 'Trạng thái',
    returned: 'Đã trả lại',
    totalBeforeDiscount: 'Tổng trước giảm giá',
    discount: 'Giảm giá',
    totalAfterDiscount: 'Tổng sau giảm giá',
    totalBreakdown: 'Phân tích tổng',
    parentOrder: 'Đơn hàng cha',
    combinedTotal: 'Tổng kết hợp',
    totalItems: 'Tổng mục',
    suborders: 'Đơn phụ',
    suborder: 'Đơn phụ',
    promotion: 'Khuyến mãi',
    promotionType: 'Loại khuyến mãi',
    promotionValue: 'Giá trị khuyến mãi',
    total: 'Tổng cộng',
    tableNumber: 'Số bàn',
    paid: 'Đã thanh toán',
    quantity: 'Số lượng',
    product: 'Sản phẩm',
    price: 'Giá',
    note: 'Ghi chú',
    sum: 'Tổng',
    searchProducts: 'Tìm kiếm sản phẩm',
    taxes: 'Thuế',
    points: 'Điểm',
    pointsRedemption: 'Điểm để đổi',
    pointsUsed: 'Điểm đã sử dụng',
    orderType: 'Loại đơn hàng',
    itemsSubtotal: 'Tổng phụ mục',
    subordersSubtotal: 'Tổng phụ đơn phụ',
    serviceFee: 'Phí dịch vụ',
    tax: 'Thuế',
    receipt: 'Hóa đơn',
    order: 'Đơn hàng',
    type: 'Loại',
    paymentQRCode: 'Mã QR thanh toán',
    checkedIn: 'Đã điểm danh',
    enterOtp: 'Nhập OTP',
    scanQrCode: 'Quét mã QR',
    scanQR: 'Quét mã QR',
    member: 'Thành viên',
    deliveryPlatform: 'Nền tảng',
  },
  deliveryPlatforms: {
    internal: 'Nội bộ',
    grab: 'Grab',
    shopee: 'Shopee',
    xanhsm: 'Xanh SM',
    customerName: 'Tên khách hàng',
  },
  section: {
    order: 'Đơn hàng',
    customer: 'Khách hàng',
    shipping_address: 'Địa chỉ giao hàng',
    items: 'Mục',
    total: 'Tổng cộng',
  },
  orderTypes: {
    dineIn: 'Dùng tại chỗ',
    takeaway: 'Mang đi',
    delivery: 'Giao hàng',
  },
  promotion: {
    none: 'Không',
    percentage: 'Phần trăm',
    fixed: 'Số tiền cố định',
  },
  notification: {
    ready_success: 'Đơn hàng đã được đánh dấu là sẵn sàng',
    ready_error: 'Lỗi: Không thể đánh dấu đơn hàng là sẵn sàng',
    cancel_success: 'Đơn hàng đã bị hủy',
    cancel_error: 'Lỗi: Không thể hủy đơn hàng',
    deliver_success: 'Đơn hàng đã được giao',
    deliver_error: 'Lỗi: Không thể giao đơn hàng',
  },
  tabs: {
    ordered: 'Đã đặt',
    ready: 'Sẵn sàng',
    delivered: 'Đã giao',
    cancelled: 'Đã hủy',
  },
  status: {
    ordered: 'Đã đặt',
    ready: 'Sẵn sàng',
    delivered: 'Đã giao',
    cancelled: 'Đã hủy',
  },
  filters: {
    dateGte: 'Từ ngày',
    dateLte: 'Đến ngày',
    totalGte: 'Tổng tối thiểu',
  },
  versions: {
    modern: 'Hiện đại',
    legacy: 'Cũ',
    active: 'Hoạt động',
  },
};
